var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"login-out",on:{"click":_vm.handleLoginOut}},[_vm._v(" 退出登录 ")]),(_vm.$store.getters.model == 'pc')?_c('PCPageV2'):_vm._e(),(_vm.$store.getters.model == 'mobile')?_c('MobilePage'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }